import React, { useState } from "react";
import axios from "axios";

import "./styles.css";
import Messages from "./Messages";

const Chat = props => {
    const [responses, setResponses] = useState([]);
    const [currMessage, setCurrMessage] = useState("");

    const handleMessageSubmit = message => {
        const data = {
            message
        };

        // console.log(data)

        //http://localhost:3001
        axios
            .post('https://trash-talk-chatbot.herokuapp.com/', data)
            .then(response => {
                // console.log(response.config.data)
                const responseData = {
                    text: response.data["message"]["fulfillmentText"] !== "" ? response.data["message"]["fulfillmentText"] : "Sorry, I can't get it. Can you please repeat once?",
                    isBot: true
                }

                // console.log(responseData)

                setResponses(responses => [...responses, responseData]);

                // console.log(responses)

            })
            .catch(error => {
                console.log("Error: ", error);
            });
    }

    const handleMessageChange = event => {
        setCurrMessage(event.target.value);
        // console.log(event.target.value)
    };

    const handleSubmit = event => {
        const message = {
            text: currMessage,
            isBot: false
        }

        if (event.key === "Enter") {
            setResponses(responses => [...responses, message]);
            // console.log(message.text)
            handleMessageSubmit(message.text);
            setCurrMessage("");
        };
    };

    // console.log(responses)


    return (
        <div className="chatSection">
            <div className="botContainer">
                <div className="messagesContainer">
                    <Messages messages={responses} />
                </div>

                {/* The input section is 👇 */}
                <div className="inputSection">
                    <input
                        type="text"
                        value={currMessage}
                        onChange={handleMessageChange}
                        onKeyDown={handleSubmit}
                        placeholder="Say something..."
                        className="messageInputField"
                    />
                </div>
            </div>
        </div>
    );
};

export default Chat;